const theme = {
    light: 'Hell',
    dark: 'Dunkel',
    toggleTheme: 'Thema Umschalten',
  } as const;

export default theme;
